import { Component, Input, OnInit } from '@angular/core';

import { Observable, filter, map } from 'rxjs';

import { Amount } from '@fcom/dapi';
import { FinnairTotalPricesDetails } from '@fcom/dapi/api/models';
import { toAmount } from '@fcom/common-booking/utils/common-booking.utils';
import { hasUnitPrices } from '@fcom/common/utils';

export enum GrandTotalTheme {
  DEFAULT = 'default',
  RENEWED = 'renewed',
}

@Component({
  selector: 'fin-grand-total',
  templateUrl: './grand-total.component.html',
  standalone: false,
})
export class GrandTotalComponent implements OnInit {
  readonly GrandTotalTheme = GrandTotalTheme;

  @Input()
  prices$: Observable<FinnairTotalPricesDetails>;

  /**
   * Theme to be shown
   */
  @Input()
  theme = GrandTotalTheme.DEFAULT;

  @Input()
  useSymbol = false;

  totalPrice$: Observable<Amount>;
  totalPoints$: Observable<number>;
  originalTotalPrice$: Observable<Amount>;

  ngOnInit(): void {
    this.totalPrice$ = this.prices$.pipe(
      filter((prices) => hasUnitPrices(prices)),
      map((data) => toAmount(data.total.total.totalAmountPaid ?? data.total.total.totalAmount))
    );

    this.totalPoints$ = this.prices$.pipe(
      filter((data) => !!data?.total?.total?.totalPoints),
      map((data) => +data.total.total.totalPoints.amount)
    );

    this.originalTotalPrice$ = this.prices$.pipe(
      filter((data) => !!data?.flight?.total?.discountReasonCode && !!data?.total?.total?.originalTotalAmount),
      map((data) => data.total.total.originalTotalAmount)
    );
  }
}
